import { z } from 'zod';
import { projectConfigSchema } from '../schemas/projectConfig';

export type ProjectConfig = z.infer<typeof projectConfigSchema>;

export interface ExtendedProjectConfig extends ProjectConfig {
  isMojPosaoBa(): boolean;
  isMojPosaoHr(): boolean;
  isVrabotuvanje(): boolean;
  isProject(name: string): boolean;
}

export function useProjectConfig(): ExtendedProjectConfig {
  const config = useRuntimeConfig();
  const projectConfig = config.public.project as ProjectConfig;

  return {
    ...projectConfig,
    isMojPosaoHr: () => projectConfig.name === 'mojposaohr',
    isMojPosaoBa: () => projectConfig.name === 'mojposaoba',
    isVrabotuvanje: () => projectConfig.name === 'vrabotuvanjemk',
    isProject: (name: string) => projectConfig.name === name,
  };
}
